window.HBPersonalisationRules = {
  placements(coordinates, productName) {
    const name = productName.toLowerCase();
    if (/sash/.test(name)) return [];
    const carryOver = /blanket|slipper|burleigh/.test(name) || (/towel/.test(name) && !/robe/.test(name));
    const kids = /kid|child|junior/.test(name);
    const stretch = /petra|mila|stretch/.test(name) && !/robe/.test(name);
    const luxe = /lux[e\s].*robe|robe.*lux/.test(name);
    const cosmetic = /cosmetic|make.?up.*bag/.test(name);
    const fonts = {
      block: { font_name: 'Block', font_code: 'garmnd' },
      cursive: { font_name: 'Cursive', font_code: 'bluebell_2' },
      serif: { font_name: 'Serif', font_code: 'garamond_regular' }
    };
    return coordinates.flatMap((original) => {
      const c = { ...original, allowed_emojis: [] };
      const area = (c.area_code + ' ' + c.area_name).toLowerCase();
      if (/bottom/.test(area)) return [];
      if (/cuff/.test(area) && /short/.test(name) && !/long/.test(name)) return [];
      if (stretch && !/piping/.test(area)) return [];
      if (luxe && /back/.test(area)) return [];
      let allowed;
      if (carryOver) {
        c.allowed_fonts = (c.allowed_fonts || []).filter(f => /^(Block|Cursive|Serif)$/i.test(f.font_name));
      } else if (/piping/.test(area)) {
        c.char_limit = 3; c.initials_only = true; allowed = ['block'];
      } else if (/cuff/.test(area)) {
        c.char_limit = 8; allowed = ['block'];
      } else if (cosmetic) {
        c.char_limit = 3; c.letters_only = true; allowed = ['block'];
      } else if (/back/.test(area)) {
        c.char_limit = 12; allowed = ['cursive'];
      } else if (/cent(re|er).*pocket/.test(area)) {
        c.char_limit = kids ? 5 : 10; allowed = ['block', 'cursive', 'serif'];
      } else if (/above.*pocket/.test(area)) {
        c.char_limit = kids ? 5 : 8; allowed = ['block', 'cursive', 'serif'];
      } else if (/robe|chest/.test(area)) {
        c.char_limit = 8; allowed = luxe ? ['serif', 'cursive'] : ['block', 'cursive', 'serif'];
      } else {
        c.allowed_fonts = (c.allowed_fonts || []).filter(f => /^(Block|Cursive|Serif)$/i.test(f.font_name));
      }
      if (allowed) c.allowed_fonts = allowed.map(key => ({ ...fonts[key] }));
      return c.allowed_fonts.length ? [c] : [];
    });
  },
  text(value, placement) {
    if (placement?.initials_only) return value.replace(/[^a-z]/gi, '').toUpperCase().slice(0, 3);
    if (placement?.letters_only) return value.replace(/[^a-z]/gi, '').slice(0, 3);
    return value.replace(/[\uFE00-\uFE0F\u200D]/g, '').replace(/[^\p{L}\p{M}\p{N} .,'’&-]/gu, '').slice(0, placement?.char_limit || 12);
  }
};
